import React from 'react'

import { twMerge } from 'tailwind-merge'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/common/TooltipV3'

import { COLOR_CLASSNAMES } from '@/constants/color'
import { DEMO_URL } from '@/constants/general'

import type { Color } from '@/types/Color'

const BetaChip: React.FC = () => {
  return (
    <div className="flex items-center gap-x-2 rounded-md border border-blue-400 dark:border-blue-600 bg-blue-400/20 dark:bg-blue-600/20 px-2 py-1">
      <span className="text-sm text-primary-900 dark:text-primary-100">
        This feature is in beta.&nbsp;
        <a
          href={DEMO_URL}
          target="_blank"
          rel="noreferrer"
          className="hover:opacity-70 underline"
        >
          Book a demo
        </a>
        &nbsp;to get a full walkthrough.
      </span>
    </div>
  )
}

interface BetaChipV2Props {
  className?: string
  tooltip?: React.ReactNode
  variant?: Color
}

export const BetaChipV2: React.FC<BetaChipV2Props> = ({
  className,
  tooltip,
  variant = 'blue',
}) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <div
          className={twMerge(
            'flex items-center gap-x-2 rounded-md border px-2.5 py-0.5 rounded-full',
            COLOR_CLASSNAMES[variant],
            className,
          )}
        >
          <span className="text-sm font-medium">Beta</span>
        </div>
      </TooltipTrigger>
      {tooltip && (
        <TooltipContent className="max-w-[300px]">{tooltip}</TooltipContent>
      )}
    </Tooltip>
  )
}

export default BetaChip
